'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Column(name, displayAs, render, onMount, sorting, autoWidth) {
  this.oi = null;
  this.tB = null;
  this.Cm = null;
  this.Jr = null;
  this.wF = null;
  this.Cl = false;
  this.oi = name;
  this.tB = displayAs;
  this.Cm = render;
  this.Jr = onMount;
  this.wF = sorting;
  this.Cl = autoWidth;
}
export { $c_Lpresto_Column as $c_Lpresto_Column };
$p = $c_Lpresto_Column.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Column;
/** @constructor */
function $h_Lpresto_Column() {
}
export { $h_Lpresto_Column as $h_Lpresto_Column };
$h_Lpresto_Column.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Column"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.oi));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tB));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cm));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Jr));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wF));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Cl ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 6);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_Column)) {
    if ((((this.Cl === x$0.Cl) && (this.oi === x$0.oi)) && (this.tB === x$0.tB))) {
      var x = this.Cm;
      var x$2 = x$0.Cm;
      var $x_2 = (x === x$2);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Jr;
      var x$4 = x$0.Jr;
      var $x_1 = (x$3 === x$4);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.wF;
      var x$6 = x$0.wF;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "Column";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.oi;
      break;
    }
    case 1: {
      return this.tB;
      break;
    }
    case 2: {
      return this.Cm;
      break;
    }
    case 3: {
      return this.Jr;
      break;
    }
    case 4: {
      return this.wF;
      break;
    }
    case 5: {
      return this.Cl;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_Column(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hU)));
}
export { $isArrayOf_Lpresto_Column as $isArrayOf_Lpresto_Column };
var $d_Lpresto_Column = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Column, "presto.Column", ({
  hU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_Column as $d_Lpresto_Column };
//# sourceMappingURL=presto.-Column.js.map
